/**
 * About Us section — official TekStar Technologies company copy, provided
 * verbatim by the business. No statistics, customers, performance figures,
 * awards, or certifications are invented here; the copy below is exactly as
 * supplied, only laid out to match the rest of the landing page.
 */

import { Box, Chip, Container, Paper, Stack, Typography } from "@mui/material";

export function AboutSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 } }} id="about">
      <Container maxWidth="md">
        <Stack alignItems="center" textAlign="center" spacing={2} mb={6}>
          <Chip label="About TekStar" color="primary" variant="outlined" sx={{ fontWeight: 600 }} />
          <Typography variant="h4" fontWeight={800}>
            Engineering the Future of Trading
          </Typography>
        </Stack>

        <Paper variant="outlined" sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
          <Typography variant="body1" color="text.secondary" mb={3} sx={{ lineHeight: 1.8 }}>
            TekStar Technologies is a technology-driven company specializing in algorithmic trading
            development, automation, and cloud-based trading solutions. We combine quantitative
            analysis, software engineering, and modern infrastructure to build intelligent trading
            systems that help traders automate strategies with precision and efficiency.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
            Our expertise includes strategy development, broker API integration, multi-strategy
            execution, cloud deployment, and real-time monitoring. We focus on delivering scalable,
            reliable, and high-performance trading platforms designed for today's dynamic financial
            markets. Our mission is to empower traders and financial innovators with robust technology
            solutions that simplify execution, enhance efficiency, and support long-term growth
            through intelligent automation.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default AboutSection;
